import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/layout/AppShell'
import { LoginPage } from './features/auth/LoginPage'
import { UsersPage } from './features/users/UsersPage'
import { Gate } from './components/layout/Gate'
import { PublicShell } from './components/layout/PublicShell'
import { EventDetailPage } from './features/events/EventDetailPage'
import { EventsPage } from './features/events/EventsPage'
import { NewEventPage } from './features/events/NewEventPage'
import { InvitationEditorPage } from './features/invitations/InvitationEditorPage'
import { CancelPage } from './features/public/CancelPage'
import { RegisterPage } from './features/public/RegisterPage'
import { UnsubscribePage } from './features/public/UnsubscribePage'
import { AuditPage } from './features/settings/AuditPage'
import { OutboxPage } from './features/settings/OutboxPage'
import { SettingsPage } from './features/settings/SettingsPage'
import { TeamsPage } from './features/teams/TeamsPage'

export default function App() {
  return (
    <Routes>
      {/* Public, unauthenticated pages reached from e-mails */}
      <Route element={<PublicShell />}>
        <Route path="/anmalan/:token" element={<RegisterPage />} />
        <Route path="/avanmalan/:token" element={<CancelPage />} />
        <Route path="/avregistrera/:token?" element={<UnsubscribePage />} />
      </Route>

      <Route path="/logga-in" element={<LoginPage />} />

      {/* Internal app */}
      <Route
        element={
          <Gate>
            <AppShell />
          </Gate>
        }
      >
        <Route index element={<EventsPage />} />
        <Route path="/event/nytt" element={<NewEventPage />} />
        <Route path="/event/:id" element={<EventDetailPage />} />
        <Route path="/event/:id/:tab" element={<EventDetailPage />} />
        <Route path="/event/:id/inbjudan/:invitationId" element={<InvitationEditorPage />} />
        <Route path="/team" element={<TeamsPage />} />
        <Route path="/utskick" element={<OutboxPage />} />
        <Route path="/logg" element={<AuditPage />} />
        <Route path="/anvandare" element={<UsersPage />} />
        <Route path="/installningar" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
